var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Statistics"},[_c('div',{staticClass:"left_box"},[_c('DataSat'),_c('Share')],1),_c('div',{staticClass:"right_box"},[_c('DataStatistics',{attrs:{"StatisticsData":_vm.StatisticsData}}),_c('Special')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }